<script setup>
    import ImageCropper from '@/components/ImageCropper';
    import ImageUpload from '@/components/client/ImageUpload';
    import ClientModal from '@/components/client/Modal';
    import { ref, reactive, watch } from 'vue';
    import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
    import SecondaryButton from '@/components/client/Buttons/SecondaryButton';

    const emits = defineEmits(['crop']);

    const props = defineProps({
        image: [String, null],
    });

    const _image = reactive({
        image: props.image,
        image_crop: props.image,
        file: null,
        tmp_file: null,
        cropper: null,
        tmp_cropper: null,
        deleted: false,
    });

    const imageUploadRef = ref(null);
    const showingCropperModal = ref(false);
    const imageCropperRef = ref(null);

    function startFileUploading() {
        imageUploadRef.value.triggerFileInputDialog();
    }

    function imageUploaded(image, file) {
        _image.image = image;
        _image.file = file;
        showingCropperModal.value = true;
        setTimeout(() => imageCropperRef.value.replace(image), 500);
    }

    function onCropReady(cropper) {
        // _image.tmp_cropper = cropper;
    }

    function onCropChange(data) {
        _image.tmp_cropper = data;
    }

    function readImage(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onerror = () => {
                reader.abort();
                reject(new DOMException('Problem parsing input file.'));
            };

            reader.onload = () => {
                resolve(reader.result);
            };

            reader.readAsDataURL(file);
        });
    };

    async function onCrop(canvas) {
        if (!canvas) return;

        _image.image_crop = canvas.toDataURL();

        if (_image.tmp_file instanceof File) {
            _image.image = await this.readImage(_image.tmp_file);
            _image.file = _image.tmp_file;
            _image.tmp_file = null;
        }

        _image.cropper = _image.tmp_cropper;
        _image.tmp_cropper = null;

        emits('crop', _image);
    }

    function performCrop() {
        imageCropperRef.value.crop();
        closeCropper();
    }

    function closeCropper() {
        imageCropperRef.value.destroy();
        showingCropperModal.value = false;
    }

    function startCropperWithImage(image) {
        showingCropperModal.value = true;
        setTimeout(() => imageCropperRef.value.replace(image), 300);
    }

    defineExpose({
        startCropperWithImage,
        startFileUploading,
    });

    // watch(() => props.showingImageUploadDialog, (currentValue, oldValue) => {
    //     if (currentValue) {
    //         startFileUploading();
    //     }
    // });
</script>

<template>
    <div>
        <client-modal :show="showingCropperModal" @close="() => showingCropperModal = false">
            <div class="p-6">
                <div class="mb-4" :class="{ 'border-2 border-blue': _image.tmp_cropper === null }">
                    <image-cropper
                        ref="imageCropperRef"
                        :zoom-on-wheel="false"
                        :zoom-on-touch="false"
                        :view-mode="1"
                        :auto-crop-area="1"
                        :aspect-ratio="4/3"
                        :zoom-slider="true"
                        :toolbar="false"
                        :background="false"
                        @ready="(cropper) => onCropReady(cropper)"
                        @on-change="(value) => onCropChange(value)"
                        @on-crop="(canvas) => onCrop(canvas)"/>
                </div>

                <div class="flex">
                    <secondary-button
                        type="button"
                        @click="startFileUploading()">
                        Byt bild
                    </secondary-button>

                    <secondary-button
                        type="button"
                        class="ml-auto mr-2"
                        @click="closeCropper()">
                        Avbryt
                    </secondary-button>

                    <primary-button
                        type="button"
                        @click="performCrop()">
                        Använd bild
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <image-upload
            ref="imageUploadRef"
            @image-selected="(image, file) => imageUploaded(image, file)"/>
    </div>
</template>
